import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {orgName,subAccounts,subAccount,subAccountResetPwd,subAccountResetLoginname,
    subAccountEventsApply,subAccountEventsApplys,subAccountExp,subAccountGuest,
    subAccountAudit,subAccountAttendee} = api

/**
 * 创建
 */
export async function createOrgName(params) {
    return request({url: orgName, method: 'put', data: params,})
}
/**
 * 查找
 */
export async function findSubAccounts(params) {
    return request({url: subAccounts, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createSubAccounts(params) {
    return request({url: subAccounts, method: 'post', data: params,})
}
/**
 * 创建
 */
export async function deleteSubAccount(params) {
    return request({url: subAccount, method: 'delete', data: params,})
}

/**
 * 重置密码
 */
export async function updateSubAccountResetPwd(params) {
    return request({url: subAccountResetPwd, method: 'post', data: params,})
}
/**
 * 重置用户名
 */
export async function updateSubAccountResetLoginname(params) {
    return request({url: subAccountResetLoginname, method: 'post', data: params,})
}

/**
 * 活动申请
 */
export async function createSubAccountEventsApplys(params) {
    return request({url: subAccountEventsApplys, method: 'post', data: params,})
}
/**
 * 活动申请查询
 */
export async function findSubAccountEventsApplys(params) {
    return request({url: subAccountEventsApplys, method: 'get', data: params,})
}
/**
 * 活动申请删除
 */
export async function deleteSubAccountEventsApply(params) {
    return request({url: subAccountEventsApply, method: 'delete', data: params,})
}
/**
 * 活动申请更新
 */
export async function updateSubAccountEventsApply(params) {
    return request({url: subAccountEventsApply+'??status='+params.status, method: 'put', data: params,})
}
/**
 * 子账号导出权限
 */
export async function findSubAccountExp(params) {
    return request({url: subAccountExp, method: 'get', data: params,})
}

export async function updateSubAccountExp(params) {
    return request({url: subAccountExp+'?allowSubAccountExport='+params.allowSubAccountExport, method: 'put', data: params,})
}
/**
 * 子账号嘉宾关联
 */
export async function findSubAccountGuest(params) {
    return request({url: subAccountGuest, method: 'get', data: params,})
}

export async function updateSubAccountGuest(params) {
    return request({url: subAccountGuest+'?must='+params.must, method: 'put', data: params,})
}
/**
 * 子账号审核参与人
 */
export async function findSubAccountAudit(params) {
    return request({url: subAccountAudit, method: 'get', data: params,})
}

export async function updateSubAccountAudit(params) {
    return request({url: subAccountAudit+'?allowAudit='+params.allowAudit, method: 'put', data: params,})
}
export async function findSubAccountAttendee(params) {
    return request({url: subAccountAttendee, method: 'get', data: params,})
}

export async function updateSubAccountAttendee(params) {
    return request({url: subAccountAttendee+'?allowAudit='+params.allowAudit, method: 'put', data: params,})
}






// WEBPACK FOOTER //
// ./src/services/subAccounts.js